<div class="signup-wrapper">
  <canvas-placeholder [showContent]="false"></canvas-placeholder>
  <div class="signup-container">
    <div>
      <mat-card class="signup-form-container">
        <form class="signup-form" [formGroup]="_form" (ngSubmit)="signUp()">
          <!-- Label -->
          <div class="signup-title">
            <ddc-text-gradient class="text-xl" [_text]="'Sign Up'" [_type]="'1'"> </ddc-text-gradient>
            <p class="text-sm">And create your first awesome dictionary.</p>
          </div>
          <!-- ! Form Error -->
          <div class="alert alert-danger" *ngIf="_form.errors">
            {{ _sigUpError }}
          </div>
          <!-- ! First name -->
          <mat-form-field class="signup-firstname">
            <mat-label>First name</mat-label>
            <input formControlName="_firstname" matInput placeholder="Ex. Mike" />
            <!-- * Errors -->
            <mat-error *ngIf="firstname.hasError('required')"> First name is <strong>required</strong> </mat-error>
            <mat-error *ngIf="firstname.hasError('maxlength')">
              Maximum <strong>{{ _maxlength }}</strong> characters.
            </mat-error>
          </mat-form-field>
          <!-- ! Last name -->
          <mat-form-field class="signup-lastname">
            <mat-label>Last name</mat-label>
            <input formControlName="_lastname" matInput placeholder="Ex. Schulz" />
            <!-- * Errors -->
            <mat-error *ngIf="lastname.hasError('required')"> Last name is <strong>required</strong> </mat-error>
            <mat-error *ngIf="lastname.hasError('maxlength')">
              Maximum <strong>{{ _maxlength }}</strong> characters.
            </mat-error>
          </mat-form-field>
          <!-- ! Username -->
          <mat-form-field class="signup-username">
            <mat-label>Username on Daydic</mat-label>
            <input formControlName="_username" matInput placeholder="Ex. mike_s96" />
            <!-- * Errors -->
            <mat-error *ngIf="username.hasError('required')"> Username is <strong>required</strong> </mat-error>
            <mat-error *ngIf="username.hasError('pattern')">
              Acceptable: Lowercases, numbers, underline and dot.
            </mat-error>
            <mat-error *ngIf="username.hasError('minlength')">
              At least <strong>{{ _minlength }}</strong> characters.
            </mat-error>
            <mat-error *ngIf="username.hasError('maxlength')">
              Maximum <strong>{{ _maxlength }}</strong> characters.
            </mat-error>
          </mat-form-field>
          <!-- ! Email -->
          <mat-form-field class="signup-email">
            <mat-label>Email</mat-label>
            <input
              formControlName="_email"
              matInput
              placeholder="Ex. pat@example.com"
              type="email"
              [errorStateMatcher]="_matcher"
            />
            <!-- * Errors -->
            <mat-error *ngIf="email.hasError('required')"> Email is <strong>required</strong> </mat-error>
            <mat-error *ngIf="email.hasError('email') && !email.hasError('required')">
              Please enter a valid email address
            </mat-error>
            <mat-error *ngIf="email.hasError('minlength')">
              At least <strong>{{ _minlength }}</strong> characters.
            </mat-error>
            <mat-error *ngIf="email.hasError('maxlength')">
              Maximum <strong>{{ _maxlength }}</strong> characters.
            </mat-error>
          </mat-form-field>
          <!-- ! Password -->
          <mat-form-field class="signup-password" appearance="fill">
            <mat-label>Enter your password</mat-label>
            <input aria-label="password" formControlName="_password" matInput [type]="_hide ? 'password' : 'text'" />
            <button
              mat-icon-button
              matSuffix
              [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="_hide"
              (click)="_hide = !_hide"
            >
              <mat-icon>{{ _hide ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            <mat-error *ngIf="password.hasError('pattern')">
              Password must have at least one <strong>lowercase</strong> letter, <strong>uppercase</strong> letter,
              <strong>number</strong> and <strong>special character</strong>(#-_+). At least 8 characters.
            </mat-error>
            <mat-error *ngIf="password.hasError('required')"> Password is <strong>required</strong> </mat-error>
          </mat-form-field>
          <!-- ! Agreement -->
          <div class="agreement-container text-sm">
            By clicking Agree & Sign Up, you agree to the Daydic
            <a
              class="font-semibold bold underline legal-info"
              color="primary"
              (click)="openTermsAndCondsDialog('termsAndConds')"
              >Terms & Conditions</a
            >,
            <a
              class="font-semibold bold underline legal-info"
              color="primary"
              (click)="openTermsAndCondsDialog('privacyPolicy')"
              >Privacy Policy</a
            >, and
            <a
              class="font-semibold bold underline legal-info"
              color="primary"
              (click)="openTermsAndCondsDialog('cookiePolicy')"
              >Cookie Policy</a
            >.
          </div>
          <!-- ! Submit button -->
          <ddc-button-s-one
            [_icon]="'celebration'"
            [_isLoading]="_isSignUpBtnLoading"
            [_label]="_submitBtnText"
          ></ddc-button-s-one>
        </form>

        <mat-divider></mat-divider>
        <!--! Route -->
        <div class="signup-login">
          <p>Already have an account?</p>
          <ddc-button-r-one
            class="signup-login-button"
            [dynamicRoute]="'/login'"
            [icon]="'login'"
            [label]="'Login'"
            [type]="'route'"
          >
          </ddc-button-r-one>
        </div>
      </mat-card>
    </div>
    <!-- <div class="carousel-container">
    <ddc-carousel [slides]="_slides"></ddc-carousel>
  </div> -->
  </div>
</div>
